import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import ToolkitSubpageLayout from "@src/layouts/ToolkitSubpageLayout";
import SEO from "@src/components/SEO";
import MarkedTranslate from "@src/components/translation/MarkedTranslate";

function Random() {
  const data = useStaticQuery(graphql`
    {
      directus {
        page_toolkit_random {
          image1 {
            filename_disk
          }
          image2 {
            filename_disk
          }
          image3 {
            filename_disk
          }
        }
      }
    }
  `);
  const {
    directus: {
      page_toolkit_random: { image1, image2, image3 },
    },
  } = data;
  return (
    <ToolkitSubpageLayout page="random" screenshots={[image1, image2, image3]}>
      <SEO
        title="page_titles.toolkit.random"
        description="page_descriptions.toolkit.random"
        image="https://static.classdojo.com/img/page_toolkit/toolkit_banner.jpg"
        twitter={{
          card: "summary_large_image",
          site: "@classdojo",
          creator: "@classdojo",
          title: "Toolkit on ClassDojo",
          description: "All your favorite teacher tools, now in the ClassDojo app :)",
          image: "https://static.classdojo.com/img/page_toolkit/toolkit_banner.jpg",
        }}
      />
      <MarkedTranslate path="directus.page_toolkit_random.text" />
    </ToolkitSubpageLayout>
  );
}

export default Random;
